import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import es from './es.json';

i18n?.use(LanguageDetector)?.use(initReactI18next)?.init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    // Use stored preference first, then browser detection
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'sj_language',
      caches: ['localStorage'],
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    interpolation: {
      // React already escapes values
      escapeValue: false,
      // Support {key} style placeholders used throughout the app
      prefix: '{',
      suffix: '}',
    },
    // Don't suspend — we have all translations bundled
    react: {
      useSuspense: false,
    },
  });

export default i18n;
